import { useMemo } from 'react';
import useSuspendableQuery from 'hooks/useSuspendableQuery';
import {
  ContentfulTrueDocsAndFormsBySlugDocument,
  ContentfulTrueDocsAndFormsFragment,
} from '__generated__/graphql';

export function useTrueForm(
  slug: string,
): ContentfulTrueDocsAndFormsFragment | null | undefined {
  const { data } = useSuspendableQuery(
    ContentfulTrueDocsAndFormsBySlugDocument,
    {
      variables: { slug },
    },
  );

  return useMemo(
    () =>
      data ? data?.contentfulTrueDocsAndFormsCollection?.items[0] : undefined,
    [data],
  );
}
